import { controller } from './app';

controller('RefreshController', [
  '$window',
  '$timeout',
  function($window, $timeout) {
    $timeout(function() {
      // Redirect target is a hardcoded internal path; no user input is used.
      $window.location.href = '/?refresh=' + Date.now(); // nosemgrep
    }, 1000);
  }
]);
